import { BareActionContext } from 'vuex-typex'
import { RootState } from '@/store'
import fetchFeedUser from '@/store/feed/actions/fetch-feed-user';
import { FeedState } from '@/store/feed/state';
import authStore from '@/store/auth/auth-store';
import setFeedUser from '@/store/feed/actions/set-feed-user';
import { IUser } from '@/model/user';
import feedStore from '@/store/feed/feed-store';

export default async function initFeed(context: BareActionContext<FeedState, RootState>)
{
  if (feedStore.feedUserId) {
    feedStore.commitSetUserId({id: feedStore.feedUserId})
    fetchFeedUser(context, parseInt(feedStore.feedUserId))
  } else if (authStore.isAuthenticated) {
    feedStore.commitSetUserId({id: (<number>(<IUser>authStore.user).id).toString()})
    setFeedUser(context, <IUser>authStore.user)
  } else {
    feedStore.commitSetUserId({id: null})
    setFeedUser(context, null)
  }

  return
}
